import {
  CustomerNumbersInfo,
  DealerAssociation
} from 'services/dealer-association/types';
import { StoreAddress } from 'components/dealer-locator/types';
import { Notification } from 'services/notifications/types';
import { useDrawer } from '@cat-ecom/pcc-components';

export interface NotificationsContentProps {
  notifications?: Notification[];
  customerNumbers?: CustomerNumbersInfo[];
  status?: string;
  storeAddress?: StoreAddress;
  isLoading?: boolean;
  isIAUser?: boolean;
  defaultDealer?: DealerAssociation;
  isQuoteEnabled?: boolean;
  userAttributes?: Array<{ name: string; value: string }>;
  calRoles?: string[];
  isPCCQuoteNotificationsFilteringFlag?: boolean;
}

export interface NotificationDetailsProps {
  notificationData?: Notification[];
  isIAUser?: boolean;
  defaultDealer?: DealerAssociation;
  storeAddress?: StoreAddress;
  handleRefresh?: () => void;
  filterDrawer: ReturnType<typeof useDrawer>;
}

export interface NotificationsFooterProps {
  onPageChange: (e: number) => void;
  currentPage: number;
  totalResultsCount: number;
  hidePagination: boolean;
  toggleValue: boolean;
  setToggleValue: (value: boolean) => void;
}

export type NotificationsCardContentProps = Pick<
  Notification,
  | 'dcn'
  | 'formattedDate'
  | 'formattedTime'
  | 'poNumber'
  | 'isRead'
  | 'orderStatus'
> & { storeAddress?: StoreAddress };

export enum OrderStatusTypes {
  OnHold = 'OH',
  OrderProblem = 'EX',
  QuoteCreated = 'NEW',
  OrderPlaced = 'OP',
  PendingOrder = 'P',
  WaitingForApproval = 'W'
}
